import { VisitDetailPhotos } from '@types-lib';

// Initial values
export function initializePhoto(): VisitDetailPhotos.Photo {
  return {
    approved: false,
    deleted: null,
    camera_side: '',
    file: {
      deleted: null,
      exam_photo_id: 0,
      filename: '',
      id: 0,
      id_type: null,
      notes: null,
      rejection_note: '',
      reviewed: '',
      reviewed_by: 0,
      status: VisitDetailPhotos.PhotoStatuses.PENDING_REVIEW,
    },
    id: 0,
    more: {
      text: '',
      title: '',
    },
    optional: false,
    text: '',
    type: '',
    notes: null,
    rejected: false,
    canBeDeleted: false,
    image_uri: '',
  };
}

export function initialiseCounts(): VisitDetailPhotos.Counts {
  return {
    approved_request_pair: 0,
    remaining_request_pair: 4,
    request_last_sent: null,
    id_and_selfie_required: 0,
    id_and_selfie_unapproved: 0,
  };
}

export function initialiseTask(): VisitDetailPhotos.Task {
  return {
    approval_required: true,
    created: '',
    flags: null,
    id: null,
    modified: '',
    name: '',
    position: null,
    settle_on_approve: true,
    status: null,
    type: null,
  };
}
